import api from '@/api'

const store = {
  state: {
    dataSaleMenuSchedule: [],
    pagingSaleMenuSchedule: {
      page: 1,
      size: 20,
      total: 0
    },
    sortingSaleMenuSchedule: {
      byField: '',
      isDesc: false
    },
    filteringSaleMenuSchedule: {
      outletCode: null,
      menuItemCode: null,
      status: null,
      beginDate: null,
      endDate: null,
      beginDay: null,
      endDay: null,
      beginHour: null,
      endHour: null
    }
  },

  mutations: {
    SET_SALEMENUSCHEDULE: (state, payload) => {
      state.dataSaleMenuSchedule = payload
    },
    SET_PAGING_PAGE_SALEMENUSCHEDULE: (state, payload) => {
      state.pagingSaleMenuSchedule.page = payload
    },
    SET_PAGING_TOTAL_SALEMENUSCHEDULE: (state, payload) => {
      state.pagingSaleMenuSchedule.total = payload
    },
    SET_SORTING_SALEMENUSCHEDULE: (state, payload) => {
      state.sortingSaleMenuSchedule = payload
    },
    SET_FILTERING_SALEMENUSCHEDULE: (state, payload) => {
      state.filteringSaleMenuSchedule = payload
    }
  },

  getters: {
    SortingSaleMenuSchedule: state => state.sortingSaleMenuSchedule,
    FilteringSaleMenuSchedule: state => state.filteringSaleMenuSchedule,
    PagingSaleMenuSchedule: state => state.pagingSaleMenuSchedule,
    GetAllSaleMenuSchedule: state => state.dataSaleMenuSchedule,
    GetOneSaleMenuSchedule: state => id =>
      state.dataSaleMenuSchedule.find(
        dataSaleMenuSchedule => dataSaleMenuSchedule.id === id
      )
  },

  actions: {
    async UpdateSortingSaleMenuSchedule({ commit, dispatch }, payload) {
      commit('SET_SORTING_SALEMENUSCHEDULE', {
        byField: payload.byField,
        isDesc: payload.isDesc
      })
      dispatch('GetAllSaleMenuSchedule')
    },

    async UpdateFilteringSaleMenuSchedule({ commit, dispatch }, isResetField) {
      if (isResetField) {
        const emptyFilter = {
          cond: null,
          code: null,
          description: null
        }
        commit('SET_FILTERING_SALEMENUSCHEDULE', emptyFilter)
      }
      commit('SET_PAGING_PAGE_SALEMENUSCHEDULE', 1)
      dispatch('GetAllSaleMenuSchedule')
    },

    async GetAllSaleMenuSchedule({ commit, state }) {
      try {
        commit('SET_IS_FETCHING_DATA', true)
        const result = await api.GetAllSaleMenuSchedule(
          state.pagingSaleMenuSchedule,
          state.sortingSaleMenuSchedule,
          state.filteringSaleMenuSchedule
        )
        commit('SET_IS_FETCHING_DATA', false)
        commit(
          'SET_PAGING_TOTAL_SALEMENUSCHEDULE',
          result.headers['data-length']
        )
        commit('SET_SALEMENUSCHEDULE', result.data.data)
        return result.data
      } catch (e) {
        commit('SET_IS_FETCHING_DATA', false)
        throw e
      }
    },

    async CreateSaleMenuSchedule({ dispatch }, payload) {
      try {
        const { data } = await api.CreateSaleMenuSchedule(payload)
        dispatch('GetAllSaleMenuSchedule')
        return data
      } catch (e) {
        return e.response
      }
    },

    async UpdateSaleMenuSchedule({ dispatch }, payload) {
      try {
        const { data } = await api.UpdateSaleMenuSchedule(payload.id, payload)
        dispatch('GetAllSaleMenuSchedule')
        return data
      } catch (e) {
        return e.response
      }
    },

    async DeleteSaleMenuSchedule({ dispatch }, id) {
      try {
        const { data } = await api.DeleteSaleMenuSchedule(id)
        dispatch('GetAllSaleMenuSchedule')
        return data
      } catch (e) {
        return e.response
      }
    }
  }
}

export default store
